export var YandexMetricaTargets;
(function (YandexMetricaTargets) {
    YandexMetricaTargets["AgentsCall"] = "agents_call";
    YandexMetricaTargets["AgentsChat"] = "agents_chat";
})(YandexMetricaTargets || (YandexMetricaTargets = {}));
